export default "__VITE_ASSET__DtzO3d5Z__"